import cn from 'clsx'
import * as React from 'react'
import { getContrastColor } from '@disco/utils/color-utils'
import Icon from 'components/ui/icon'
import styles from './index.module.css'

type Props = {
  color: string
  isActive: boolean
  className?: string
}
export default function ColorItem({
  color,
  isActive,
  className,
  ...props
}: Props): React.ReactElement<'div'> {
  const classNames = cn(className, styles.colorItem, {
    [styles.colorItemIsActive]: isActive,
  })
  return (
    <div {...props} className={classNames}>
      <div
        className={styles.colorItemColor}
        data-color={color}
        style={{
          backgroundColor: color,
        }}
      >
        {isActive && (
          <Icon
            className={styles.colorItemColorCheckbox}
            type="check"
            color={getContrastColor(color)}
          />
        )}
      </div>
    </div>
  )
}
